import { createRuntimeFn } from '@vanilla-extract/recipes/createRuntimeFn';

var tag = 'tag_tag__1wjql6d5';
var tagBackground = 'var(--tag-background__1wjql6d1)';
var tagColor = 'var(--tag-color__1wjql6d0)';
var tagHorizontalGap = 'var(--tag-horizontal-gap__1wjql6d4)';
var tagVariants = createRuntimeFn({defaultClassName:'tag__1wjql6d6',variantClassNames:{size:{small:'tag_tagVariants_size_small__1wjql6d7','default':'tag_tagVariants_size_default__1wjql6d8',large:'tag_tagVariants_size_large__1wjql6d9'},variant:{weak:'tag_tagVariants_variant_weak__1wjql6da',solid:'tag_tagVariants_variant_solid__1wjql6db',outline:'tag_tagVariants_variant_outline__1wjql6dc'}},defaultVariants:{},compoundVariants:[]});

export { tag, tagBackground, tagColor, tagHorizontalGap, tagVariants };
//# sourceMappingURL=tag.vanilla.mjs.map
